<div class="composable-input-root"
  role="textbox"
  aria-multiline="true"
  tabindex="-1">
  @if (messages.length > 0) {
  @for (msg of messages; track $index; let i = $index) {
  @if (isString(msg)) {
  <input class="composable-input-text"
    spellcheck="true"
    dir="ltr"
    [attr.data-index]="i"
    [attr.placeholder]="isPlaceholder && i === 0 ? placeholder : '' "
    [ngClass]="{ 'placeholder': isPlaceholder && i === 0 }"
    [value]="msg"
    [style.font-size.px]="INPUT_FONT_SIZE"
    [style.width]="getInputWidth(i)"
    (input)="onTextInput($event, i)"
    (keyup)="onTextKeyup($event, i)"
    (keydown)="onTextKeydown($event)"
    (click)="onClickInput($event, i)"
    #textInput>
  } @else {
  <div class="composable-input-component-block"
    [attr.data-index]="i"
    contenteditable="false"
    tabindex="-1">
    <ng-container *ngComponentOutlet="msg.component; inputs: msg.data;injector: injector">
    </ng-container>
  </div>
  }
  }
  }
</div>